import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MyToasterService } from '../../../../services/my-toaster.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StatusProcessAPI } from '../../../../api/status_process.api';
import { ProcessAPI } from '../../../../api/process.api';
import { ProcessStatusService } from '../../../../services/process-status.service';
import { SessionStorageService } from '../../../../services/session-storage.service';
@Component({
	selector: 'process-app-modal',
	templateUrl: './process-modal.component.html',
	styleUrls: ['./process-modal.component.scss']
})
export class ProcessModalComponent implements OnInit {
	constructor(
		private activeModal: NgbActiveModal,
		private myToaster: MyToasterService,
		private processStatusService: ProcessStatusService,
		private processAPI: ProcessAPI,
		private statusProcessApi: StatusProcessAPI,
		private session: SessionStorageService,
		private route: Router,
  ) { }
	public selectedTableData: any;

	public dados: any = {
		message: '',
		userId: this.session.getUserId(),
		...this.processStatusService.getProcessStatusData(),
	};
	public fetchedStatus = [];

	public isAllProcessSelected: boolean = false;

	async ngOnInit() {
		await this.getAllProcessStatus()
		
		const { allProcessSelected } = this.processStatusService.getProcessStatusData()

		this.isAllProcessSelected = allProcessSelected
  }
  
	public async onSubmit() {
		try {
			this.myToaster.showLoading('Vinculando dados...');
			await this.processAPI.updateManyStatusProcess(this.dados)
			console.log(this.dados)
			this.activeModal.close();
			this.myToaster.showSuccessToast('Status atualizados com sucesso.');
			this.myToaster.hideLoading();
			this.route.navigate(['/pages/home'])
		} catch (err) {
			this.myToaster.hideLoading();
			this.myToaster.showErrorToast('Não foi possivel atualizar os status.', err);
		}
	}

	public close() {
		this.activeModal.close();
	}

	public async getAllProcessStatus(){
		await this.statusProcessApi.list().then(statusResponse => {
			this.fetchedStatus = statusResponse;
		})
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/process/modal/process-modal.component.ts